import { takeLatest, put, call, take } from 'redux-saga/effects';
import { api } from 'services/api';
import { notificationContainer } from 'utils/notificationContainer';
import axios from 'axios';
import {
	updateGoodsRequest,
	updateGoodsSuccess,
	deleteGoodsRequest,
	deleteGoodsSuccess,
} from './reducer';
import { IUpdateGoodsPayload, IDeleteGoodsPayload } from './types';
import { refreshTokenByTimeOutRequest, refreshTokenByTimeOutSuccess } from '../auth/reducer';
import { getShopGoodsRequest } from '../shops/reducer';

function* updateGoodsSaga(action: { type: string; payload: IUpdateGoodsPayload }) {
	try {
		yield put(refreshTokenByTimeOutRequest());
		yield take(refreshTokenByTimeOutSuccess.type);

		yield call(api.goods.updateGoods, action.payload.body);
		yield put(updateGoodsSuccess());
		if (action.payload.requestGoods) {
			yield put(getShopGoodsRequest(action.payload.requestGoods));
		}
	} catch (error) {
		notificationContainer(error instanceof Error ? error.message : 'Unknown error', 'error');
	}
}

function* deleteGoodsSaga(action: { type: string; payload: IDeleteGoodsPayload }) {
	try {
		yield put(refreshTokenByTimeOutRequest());
		yield take(refreshTokenByTimeOutSuccess.type);

		yield call(api.goods.deleteGoods, action.payload.body);
		yield put(deleteGoodsSuccess());
		if (action.payload.requestGoods) {
			yield put(getShopGoodsRequest(action.payload.requestGoods));
		}
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(error?.response?.data?.message ?? error.message ?? 'Error', 'error');
		}
	}
}

export function* goodsSaga() {
	yield takeLatest(updateGoodsRequest.type, updateGoodsSaga);
	yield takeLatest(deleteGoodsRequest.type, deleteGoodsSaga);
}
